import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withStyles } from 'material-ui/styles';
import Toolbar from 'material-ui/Toolbar';
import Drawer from 'material-ui/Drawer';
import SwipeableDrawer from 'material-ui/SwipeableDrawer';
import Typography from 'material-ui/Typography';
import Divider from 'material-ui/Divider';
import Hidden from 'material-ui/Hidden';

import { APP_DRAWER_WIDTH } from 'constants/globals';
import NavItems from './NavItems';

const styles = theme =>({
  root: {
    [theme.breakpoints.up('lg')]: {
      width: `${APP_DRAWER_WIDTH}px`,
    }
  },
  paper: {
    width: APP_DRAWER_WIDTH,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary[500],
    },
  },
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
});

export class AppDrawer extends Component{
  render(){
    const { classes, disablePermanent, onClose, onOpen, navPaths, open } = this.props;
    const drawer = (
      <div className={ classes.nav }>
        <Toolbar className={ classes.toolbar }>
          <Link className={ classes.title } to="/"
            data-test="home-link"
            onClick={ onClose }>
            <Typography type="title" gutterBottom color="inherit">
              Stackup Design
            </Typography>
          </Link>
          <Divider absolute />
        </Toolbar>
        <NavItems
          navPaths={ navPaths  }
          onItemClick={onClose}
        />
      </div>
    )

    return (
      <div>
        <Hidden lgUp={!disablePermanent}>
          <SwipeableDrawer
            data-test="drawer"
            variant="temporary"
            className={ classes.root}
            type="temporary"
            classes={{
              paper: classnames(classes.paper, 'algoria-drawer')
            }}
            open={open}
            onClose={onClose}
            onOpen={onOpen}
            ModalProps={{ keepMounted: true }}
          >
            { drawer }
          </SwipeableDrawer>
        </Hidden>
        {disablePermanent ? null : (
          <Hidden mdDown implementation="css">
            <Drawer
              data-test="drawer"
              variant="permanent"
              className={classes.root}
              type="permanent"
              classes={{
                paper: classes.paper,
              }}
              open={true}
            >
              { drawer }
            </Drawer>
          </Hidden>

        ) }
      </div>
    );
  }
}

AppDrawer.propTypes = {
  classes:          PropTypes.object.isRequired,
  disablePermanent: PropTypes.bool.isRequired,
  onClose:          PropTypes.func.isRequired,
  open:             PropTypes.bool.isRequired,
  navPaths:         PropTypes.array.isRequired,
}

export default withStyles(styles)(AppDrawer);



// WEBPACK FOOTER //
// ./src/components/AppDrawer.js